import { ReactNode } from "react";

import OpenBoxIcon from "@assets/icons/open-box-icon.svg";
import BgEllipse from "@assets/icons/bg-ellipse-3.svg";
import BgOne from "@assets/icons/bg-1-icon.svg";
import BgTwo from "@assets/icons/bg-2-icon.svg";

import { cn } from "@utils/tailwind.util";

type OverlayPosition = "top" | "bottom-right";

interface Props {
  className: string;
  icon: ReactNode;
  largeIcon?: ReactNode;
  leftImage?: ReactNode;
  rightImage?: ReactNode;
  overlayPosition?: OverlayPosition;
}

export function BackgroundSection({
  className,
  icon,
  largeIcon,
  leftImage,
  rightImage,
  overlayPosition = "top",
}: Props) {
  const overlayPositionClass =
    overlayPosition === "bottom-right"
      ? "bottom-0 right-0 translate-x-[15%] translate-y-[15%]"
      : "-top-[15px] left-1/2 -translate-x-1/2";

  return (
    <div className="relative w-full py-4">
      {/* Background layers — centered vertically over the content */}
      <BgEllipse className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[1] w-[60%] h-auto opacity-50" />
      <BgOne className="absolute inset-x-0 top-1/2 -translate-y-1/2 w-full h-auto z-[2]" />
      <BgTwo className="absolute inset-x-0 top-1/2 -translate-y-1/2 w-full h-auto z-[3]" />

      {/* Foreground row — defines the natural container height */}
      <div className="relative z-[4] w-full max-w-[480px] mx-auto px-6">
        <div className="flex items-center justify-between">
          {/* Left column */}
          <div className="basis-1/3 flex justify-center">{leftImage}</div>

          {/* Center column: large icon + refresh overlay */}
          <div className="basis-1/3 flex justify-center">
            <div className="relative flex items-center justify-center">
              {largeIcon ?? <OpenBoxIcon width={56} height={38} />}

              <div
                className={cn(
                  "absolute z-[5] flex justify-center items-center w-[26px] h-[26px] rounded-full",
                  overlayPositionClass,
                  className
                )}
              >
                {icon}
              </div>
            </div>
          </div>

          {/* Right column */}
          <div className="basis-1/3 flex justify-center">{rightImage}</div>
        </div>
      </div>
    </div>
  );
}
